import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { ConnectionService } from '../../shared/services/Connection/connection.service';
import { CacheService } from '../../shared/services/Cache/cache.service';
import { Company, placeCounter, typeInterface } from 'src/app/shared/Interfaces/company';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/shared/services/API/api.service';
import { OrderService } from 'src/app/shared/services/Order/order.service';
import { LogsService } from 'src/app/shared/services/logs.service';

@Injectable({
  providedIn: 'root',
})

export class ConnectionGuard implements CanActivate {

  company!: Company;

  constructor(
    private router: Router,
    private connection: ConnectionService,
    private cacheService: CacheService,
    private apiService: ApiService,
    private orderService: OrderService,
    private logsService: LogsService
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    const [_, nameCompany] = state.url.split('/');

    //Resgata o cache do QrCode e do Balcão
    let local = this.cacheService.getItemLocal('qrCode_key');
    let counter = this.cacheService.getItemLocal('counter_key');

    //Verifica se o cache do QrCode existe e se não expirou
    if(local && !this.cacheService.getItemLocalTimeout('qrCode_key'))
    {
      this.router.navigate(['/Authentication']);
      this.logsService.sendLogs("Qr Code Mesa Expirado", "warn");
      return false;
    }

    //Verifica se o cache do Balcão existe e se não expirou
    if(counter && !this.cacheService.getItemLocalTimeout('counter_key'))
    {
      this.router.navigate(['/Authentication']);
      this.logsService.sendLogs("Qr Code Balcão Expirado", "warn");
      return false;
    }
    

    const type: typeInterface = 
      counter ? { type: 3, qrCodeNumber: counter.data, numberParam: 0 } //Balcão
      : local ? { type: local.type, qrCodeNumber: local.data, numberParam: 0 } //Mesa
      : { type: 0, qrCodeNumber: '0', numberParam: 0 }; //Delivery

      
    this.connection.updateType(type);
    this.connection.getCompany(nameCompany, type.type).subscribe((data) => {});

    if(counter){
      return this.handleCounterFlow(counter)
    }

    return true
  }

  //Fluxo de Balcão para caso o balcão esteja tenha localização.
  private handleCounterFlow(counter: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {

      //Valida se já não foi carregado
      if (this.orderService.currentPlace.id_place != '') {
        observer.next(true);
        observer.complete();
        return;
      }

      this.apiService.getPlacesCounter(counter.data).subscribe(
      (data) =>{
        // ✅ Sem localização → pode seguir
        if (data.length === 0) {
          console.warn('Balcão sem localização, seguindo normalmente');
          this.logsService.sendLogs("Balcão sem localização", "sucess", counter.data);
          observer.next(true);
          observer.complete();
          return;
        }

        const placeData = data[0];

        // ❌ Localização inválida
        if (placeData.deleted === 1 || placeData.active === 0) {
          this.router.navigate(['/Authentication']);
          this.logsService.sendLogs("Balcão com localização inativa", "warn", counter.data);
          observer.next(false);
          observer.complete();
          return;
        }

        // ✅ Localização válida
        const place: placeCounter = {
          id_place: placeData.id_place,
          placeName: placeData.placeName
        };

        this.orderService.updatePlace(place);

        this.logsService.sendLogs("Balcão com localização", "sucess", counter.data);
        observer.next(true);
        observer.complete();

      },
      (error) =>{
        console.error('Erro ao validar localização', error);
        this.router.navigate(['/Authentication']);
        this.logsService.sendLogs("Erro ao validar localização", "error", counter.data);
        observer.next(false);
        observer.complete();

      });


    });
  }

}
